export const PIPELINE_STATUSES = {
  CREATED: 'CREATED',
  UPLOADING: 'UPLOADING',
  PARSING: 'PARSING',
  CLASSIFYING: 'CLASSIFYING',
  INGESTING: 'INGESTING',
  STAGING: 'STAGING',
  RULES_APPLIED: 'RULES_APPLIED',
  DEDUPING: 'DEDUPING',
  MATCHING: 'MATCHING',
  PENDING_REVIEW: 'PENDING_REVIEW',
  COMMITTING: 'COMMITTING',
  COMPLETE: 'COMPLETE',
  PARTIAL_COMPLETE: 'PARTIAL_COMPLETE',
  NEEDS_USER_CLASSIFICATION: 'NEEDS_USER_CLASSIFICATION',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
};

export const TERMINAL_STATUSES = [
  PIPELINE_STATUSES.COMPLETE,
  PIPELINE_STATUSES.PARTIAL_COMPLETE,
  PIPELINE_STATUSES.CANCELLED,
  PIPELINE_STATUSES.FAILED,
];

export const INTERACTIVE_STATUSES = [
  PIPELINE_STATUSES.NEEDS_USER_CLASSIFICATION,
  PIPELINE_STATUSES.PENDING_REVIEW,
];

export const PIPELINE_STEPS = [
  { key: PIPELINE_STATUSES.UPLOADING, label: 'Upload' },
  { key: PIPELINE_STATUSES.PARSING, label: 'Parse' },
  { key: PIPELINE_STATUSES.CLASSIFYING, label: 'Classify' },
  { key: PIPELINE_STATUSES.STAGING, label: 'Stage' },
  { key: PIPELINE_STATUSES.DEDUPING, label: 'Dedup' },
  { key: PIPELINE_STATUSES.MATCHING, label: 'Match' },
  { key: PIPELINE_STATUSES.PENDING_REVIEW, label: 'Review' },
  { key: PIPELINE_STATUSES.COMMITTING, label: 'Commit' },
];

export const SOURCE_KINDS = {
  BANK: 'BANK',
  LEDGER: 'LEDGER',
  SUPPLIER: 'SUPPLIER',
  DOCUMENT: 'DOCUMENT',
  UNSPECIFIED: 'UNSPECIFIED',
};

export const DATE_FORMAT_CONFIDENCE = {
  CERTAIN: 'CERTAIN',
  ASSUMED: 'ASSUMED',
};

export const STAGING_ROW_STATUSES = {
  PENDING_MATCH: 'PENDING_MATCH',
  PENDING_REVIEW: 'PENDING_REVIEW',
  CONFIRMED: 'CONFIRMED',
  DUPLICATE_SKIPPED: 'DUPLICATE_SKIPPED',
  DEDUP_OVERRIDDEN: 'DEDUP_OVERRIDDEN',
  COMMITTED: 'COMMITTED',
  COMMIT_ERROR: 'COMMIT_ERROR',
  SPLIT: 'SPLIT',
  UNMATCHED: 'UNMATCHED',
};

export const MATCH_STATUSES = {
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  PENDING_REVIEW: 'PENDING_REVIEW',
};

export const QUALITY_LEVELS = {
  ESTIMATED: 1,
  SPEND: 2,
  ACTIVITY: 3,
  METERED: 4,
};

export const QUALITY_TIERS = {
  1: { name: 'Estimated', label: 'Estimated', color: 'text-muted-foreground' },
  2: { name: 'Bronze', label: 'Bronze', color: 'text-warning' },
  3: { name: 'Silver', label: 'Silver', color: 'text-info' },
  4: { name: 'Gold', label: 'Gold', color: 'text-success' },
};

export const QUALITY_TIER_NAMES = {
  ESTIMATED: 'Estimated',
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
};

export const UNCERTAINTY_BY_TIER = {
  1: 0.5,
  2: 0.4,
  3: 0.15,
  4: 0.05,
};

export const SUPPORTED_FILE_TYPES = [
  '.csv',
  '.xlsx',
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.tiff',
  '.webp',
];

export const SUPPORTED_MIME_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/webp',
];

export const SUPPORTED_DATE_FORMATS = [
  { pattern: 'dd/MM/yyyy', example: '15/03/2025' },
  { pattern: 'MM/dd/yyyy', example: '03/15/2025' },
  { pattern: 'yyyy-MM-dd', example: '2025-03-15' },
  { pattern: 'dd-MM-yyyy', example: '15-03-2025' },
  { pattern: 'MM-dd-yyyy', example: '03-15-2025' },
  { pattern: 'dd.MM.yyyy', example: '15.03.2025' },
  { pattern: 'MM.dd.yyyy', example: '03.15.2025' },
];

export const DATA_KINDS = {
  ACTIVITY: 'ACTIVITY',
  SPEND: 'SPEND',
  MIXED: 'MIXED',
};

export const POLLING_INTERVAL_MS = 3000;
export const MAX_POLLING_INTERVAL_MS = 15000;
export const AUTO_CONFIRM_THRESHOLD = 0.85;
